/* Custom Cart Error Handler - Gaming Themed Validation Popup */

// Function to create and show gaming-themed validation popup
function showGamingValidationPopup(message, targetElement) {
  if (!targetElement || !message || message.trim() === '') return;
  
  // Remove any existing popups for this element
  removeGamingValidationPopup(targetElement);
  
  // Create popup container
  const popup = document.createElement('div');
  popup.className = 'gaming-validation-popup';
  popup.setAttribute('data-validation-popup', 'true');
  
  // Create popup content
  const content = document.createElement('div');
  content.className = 'gaming-validation-popup-content';
  
  // Create icon
  const icon = document.createElement('div');
  icon.className = 'gaming-validation-popup-icon';
  icon.textContent = '!';
  
  // Create message
  const messageEl = document.createElement('div');
  messageEl.className = 'gaming-validation-popup-message';
  messageEl.textContent = message;
  
  // Assemble popup
  content.appendChild(icon);
  content.appendChild(messageEl);
  popup.appendChild(content);
  
  // Position popup relative to the input element
  const container = targetElement.closest('.quantity') || targetElement.closest('.quantity-popover-wrapper') || targetElement.parentElement;
  if (container) {
    // Make container relative if not already
    const containerStyle = getComputedStyle(container);
    if (containerStyle.position === 'static') {
      container.style.position = 'relative';
    }
    
    container.appendChild(popup);
    
    // Show popup with animation
    setTimeout(() => {
      popup.classList.add('show');
    }, 10);
  }
  
  // Add visual feedback to input
  targetElement.classList.add('gaming-validation-error');
  targetElement.setAttribute('data-invalid', 'true');
  
  // Auto-hide after delay
  setTimeout(() => {
    removeGamingValidationPopup(targetElement);
  }, 4000);
}

// Function to remove gaming validation popup
function removeGamingValidationPopup(targetElement) {
  if (!targetElement) return;
  
  // Remove visual feedback from input
  targetElement.classList.remove('gaming-validation-error');
  targetElement.removeAttribute('data-invalid');
  
  // Find and remove popup
  const container = targetElement.closest('.quantity') || targetElement.closest('.quantity-popover-wrapper') || targetElement.parentElement;
  if (container) {
    const existingPopup = container.querySelector('[data-validation-popup]');
    if (existingPopup) {
      existingPopup.classList.remove('show');
      setTimeout(() => {
        if (existingPopup.parentNode) {
          existingPopup.parentNode.removeChild(existingPopup);
        }
      }, 300);
    }
  }
}

// Function to show cart errors using custom gaming popup
function showCartErrorAsValidation(message, targetElement) {
  if (targetElement && message && message.trim() !== '') {
    // Prevent native validation popup
    targetElement.setCustomValidity('');
    
    // Show our custom gaming popup
    showGamingValidationPopup(message, targetElement);
    
    // Add a subtle focus effect
    targetElement.focus();
    setTimeout(() => {
      targetElement.blur();
    }, 100);
  }
}

// Function to handle cart error messages
function handleCartErrors() {
  const errorBoxes = document.querySelectorAll('.cart-item__error');
  
  errorBoxes.forEach(errorBox => {
    const errorText = errorBox.querySelector('.cart-item__error-text');
    
    if (errorText) {
      // Create a MutationObserver to watch for changes to the error text
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            const errorMessage = errorText.textContent.trim();
            
            if (errorMessage !== '') {
              // Find the associated quantity input for this error
              const cartItem = errorBox.closest('.cart-item');
              const quantityInput = cartItem ? cartItem.querySelector('.quantity__input') : null;
              
              if (quantityInput) {
                // Show error using native validation popup
                showCartErrorAsValidation(errorMessage, quantityInput);
              }
              
              // Clear the error text to prevent the red box from showing
              errorText.innerHTML = '';
            }
          }
        });
      });
      
      // Start observing
      observer.observe(errorText, {
        childList: true,
        characterData: true,
        subtree: true
      });
      
      // Initial check for existing errors
      const existingError = errorText.textContent.trim();
      if (existingError !== '') {
        const cartItem = errorBox.closest('.cart-item');
        const quantityInput = cartItem ? cartItem.querySelector('.quantity__input') : null;
        
        if (quantityInput) {
          showCartErrorAsValidation(existingError, quantityInput);
        }
        
        // Clear the error text
        errorText.innerHTML = '';
      }
    }
  });
}

// Override the cart.js updateLiveRegions function to intercept error messages
function interceptCartErrors() {
  // Find the cart items element
  const cartItemsElement = document.querySelector('cart-items');
  
  if (cartItemsElement && cartItemsElement.updateLiveRegions) {
    const originalUpdateLiveRegions = cartItemsElement.updateLiveRegions;
    
    cartItemsElement.updateLiveRegions = function(line, message) {
      if (message && message.trim() !== '') {
        // Find the quantity input for this line
        const quantityInput = document.getElementById(`Quantity-${line}`);
        
        if (quantityInput) {
          // Show error using our custom gaming popup
          showGamingValidationPopup(message, quantityInput);
          
          // Don't call the original function to prevent red box
          return;
        }
      }
      
      // Call original function for non-error cases
      originalUpdateLiveRegions.call(this, line, '');
    };
  }
  
  // Also intercept cart form submissions to prevent native validation
  const cartForm = document.getElementById('cart');
  if (cartForm && !cartForm.dataset.gamingValidationAdded) {
    cartForm.dataset.gamingValidationAdded = 'true';
    
    cartForm.addEventListener('submit', function(e) {
      // Check all quantity inputs for validity
      const quantityInputs = this.querySelectorAll('.quantity__input');
      let hasErrors = false;
      
      quantityInputs.forEach(input => {
        const value = parseInt(input.value);
        const min = parseInt(input.dataset.min || input.getAttribute('min'));
        const max = parseInt(input.max);
        const step = parseInt(input.step);
        
        let message = '';
        
        if (isNaN(value) || value < min) {
          message = `This item has a minimum of ${min}`;
          hasErrors = true;
        } else if (max && value > max) {
          message = `This item has a maximum of ${max}`;
          hasErrors = true;
        } else if (step && value % step !== 0) {
          message = `Please select quantities in multiples of ${step}`;
          hasErrors = true;
        }
        
        if (message) {
          showGamingValidationPopup(message, input);
          input.setCustomValidity(''); // Prevent native popup
        }
      });
      
      if (hasErrors) {
        e.preventDefault();
        return false;
      }
    });
  }
}

// Override native HTML5 validation for quantity inputs
function interceptNativeValidation() {
  // Find all quantity inputs
  const quantityInputs = document.querySelectorAll('.quantity__input');
  
  quantityInputs.forEach(input => {
    // Don't replace the element, just add our validation override
    if (input.dataset.gamingValidationAdded) return; // Prevent duplicate listeners
    
    // Mark as processed
    input.dataset.gamingValidationAdded = 'true';
    
    // Override the invalid event
    input.addEventListener('invalid', function(e) {
      e.preventDefault(); // Prevent native validation popup
      
      let message = '';
      const value = parseInt(this.value);
      const min = parseInt(this.dataset.min || this.getAttribute('min'));
      const max = parseInt(this.max);
      const step = parseInt(this.step);
      
      if (value < min) {
        message = `This item has a minimum of ${min}`;
      } else if (max && value > max) {
        message = `This item has a maximum of ${max}`;
      } else if (step && value % step !== 0) {
        message = `Please select quantities in multiples of ${step}`;
      }
      
      if (message) {
        showGamingValidationPopup(message, this);
      }
    });
    
    // Handle input changes to clear validation
    input.addEventListener('input', function() {
      removeGamingValidationPopup(this);
      // Clear custom validity to prevent native popup
      this.setCustomValidity('');
    });
    
    // Override form validation on blur/change
    input.addEventListener('blur', function() {
      const value = parseInt(this.value);
      const min = parseInt(this.dataset.min || this.getAttribute('min'));
      const max = parseInt(this.max);
      const step = parseInt(this.step);
      
      let message = '';
      
      if (isNaN(value) || value < min) {
        message = `This item has a minimum of ${min}`;
        this.value = min; // Reset to minimum
      } else if (max && value > max) {
        message = `This item has a maximum of ${max}`;
        this.value = max; // Reset to maximum
      } else if (step && value % step !== 0) {
        message = `Please select quantities in multiples of ${step}`;
        // Round to nearest valid step
        this.value = Math.round(value / step) * step;
      }
      
      if (message) {
        showGamingValidationPopup(message, this);
      }
      
      // Always clear custom validity to prevent native popups
      this.setCustomValidity('');
    });
  });
}

// Run on DOM load
document.addEventListener('DOMContentLoaded', () => {
  handleCartErrors();
  interceptCartErrors();
  interceptNativeValidation();
});

// Also run when the page is loaded (for cases where DOM is already ready)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    handleCartErrors();
    interceptCartErrors();
    interceptNativeValidation();
  });
} else {
  handleCartErrors();
  interceptCartErrors();
  interceptNativeValidation();
}

// Handle cart updates via custom elements
function setupCartInterception() {
  const cartItemsElement = document.querySelector('cart-items');
  if (cartItemsElement) {
    interceptCartErrors();
    interceptNativeValidation();
    
    // Re-initialize validation after cart updates
    const observer = new MutationObserver((mutations) => {
      let shouldReinitialize = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if new quantity inputs were added
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.querySelector && node.querySelector('.quantity__input')) {
                shouldReinitialize = true;
              }
            }
          });
        }
      });
      
      if (shouldReinitialize) {
        setTimeout(() => {
          interceptNativeValidation();
        }, 100);
      }
    });
    
    observer.observe(cartItemsElement, {
      childList: true,
      subtree: true
    });
  } else {
    // Retry after a short delay if cart-items not found
    setTimeout(setupCartInterception, 100);
  }
}

// Setup interception when cart is ready
setupCartInterception();
